/**
 * Resolve a card-network brand string from Pluggy (e.g., 'VISA', 'Mastercard',
 * 'AMERICAN EXPRESS', 'Elo') to a static asset under `/public/brands/`.
 *
 * Returns null when the brand isn't recognized — callers fall back to a
 * generic icon (e.g., a credit-card glyph).
 */

export type CardBrand = 'visa' | 'mastercard' | 'amex' | 'elo';

const KNOWN: ReadonlySet<CardBrand> = new Set(['visa', 'mastercard', 'amex', 'elo']);

export function normalizeCardBrand(raw: string | null | undefined): CardBrand | null {
  if (!raw) return null;
  const v = raw.toLowerCase().replace(/[\s_-]+/g, '');
  if (v.includes('visa')) return 'visa';
  if (v.includes('master')) return 'mastercard';
  if (v.includes('amex') || v.includes('americanexpress')) return 'amex';
  if (v.includes('elo')) return 'elo';
  if (KNOWN.has(v as CardBrand)) return v as CardBrand;
  return null;
}

export function cardBrandImage(brand: CardBrand): string {
  return `/brands/${brand}.svg`;
}
